import { useOverlayScale } from "../editor/hooks";
import { cn } from "@acdc2/ui/lib/utils";
import { Moveable } from "../ui/Moveable";

type Props = {
  cx: number;
  cy: number;
  direction: "horizontal" | "vertical" | "primary" | "secondary";
  onMove: (movementX: number, movementY: number) => void;
  onDone: () => void;
};

export function RegionTransformHandle({
  cx,
  cy,
  direction,
  onMove,
  onDone,
}: Props) {
  const overlayScale = useOverlayScale();

  const onClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <Moveable onMove={onMove} onDone={onDone}>
      <rect
        x={cx - 6 / overlayScale}
        y={cy - 6 / overlayScale}
        width={12 / overlayScale}
        height={12 / overlayScale}
        strokeWidth={4 / overlayScale}
        className={cn(
          "pointer-events-auto fill-white stroke-brand focus:fill-brand focus:outline-hidden",
          {
            "cursor-ns-resize": direction === "vertical",
            "cursor-ew-resize": direction === "horizontal",
            "cursor-nesw-resize": direction === "primary",
            "cursor-nwse-resize": direction === "secondary",
          },
        )}
        onClick={onClick}
        tabIndex={0} // Enable receiving keyboard events + focus styles
      />
    </Moveable>
  );
}
